
import { Component, Input, Output, EventEmitter, AfterContentInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material';
import { WTimeDialogComponent } from '../w-time-dialog/w-time-dialog.component';
import { ITime } from '../w-clock/w-clock.component';
import { FormControl, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Subscription } from 'rxjs';

export class InputValidator {
  constructor(
    public validator: ValidatorFn,
    public nombre: string
  ) { }
}

@Component({
  selector: 'w-mat-timepicker',
  styleUrls: ['./w-mat-timepicker.component.scss'],
  templateUrl: './w-mat-timepicker.component.html'
})
export class WMatTimePickerComponent implements AfterContentInit, OnDestroy {
  @Input() userTime: ITime;
  @Input() placeHolder: string = 'Seleccione la hora';
  @Input() invalidMensaje: string = null;
  @Input() hintMensaje: string = null;
  @Output() onChange: EventEmitter<string> = new EventEmitter();
  @Input() color: string;
  @Output() timeChange = new EventEmitter();
  inputValidators = <InputValidator[]>[];
  public horaFormControl = new FormControl('');
  private _subscription: Subscription;

  maxTimeMensajeTime: string;
  private maxtimeValidatorFn(maxTimeInput: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      if (!control.value) {
        return null;
      }

      // minutos ingresados por el usuario
      var timeValueInput = control.value.split(':');
      var minutosIngresados = ((+timeValueInput[0]) * 60) + (+timeValueInput[1]);

      // minutos máximos que puede ingresar
      var timeMaxInput = maxTimeInput.split(':');
      var maxtime = ((+timeMaxInput[0]) * 60) + (+timeMaxInput[1]);

      if (minutosIngresados >= maxtime) {
        return <ValidationErrors>{
          'maxtime': true // maxtime superado
        };
      }

      return null; // TODO OK;     
    }
  }

  constructor(
    private dialog: MatDialog
  ) { }

  ngAfterContentInit(): void {
    this._subscription = this.horaFormControl.valueChanges.subscribe(value => {
      setTimeout(() => {
        this.timeChange.emit(this.time);
      }, 300);
    });
  }

  @Input() public set disabled(disabled: boolean) {
    if (disabled) {
      this.horaFormControl.disable({ onlySelf: true });
    } else {
      this.horaFormControl.enable({ onlySelf: true });
    }
  }

  @Input() public set required(required: boolean) {
    if (required) {
      this.inputValidators.push(new InputValidator(
        Validators.required,
        "required"
      ));
    } else {
      this.inputValidators.forEach((inputvalidator: InputValidator, index: number) => {
        if (inputvalidator.nombre == 'required') {
          this.inputValidators.splice(index, 1);
          return;
        }
      });
    }

    this.horaFormControl.setValidators(this.inputValidators.map((inputvalidator: InputValidator) => {
      return inputvalidator.validator;
    }));

    this.horaFormControl.updateValueAndValidity(this.horaFormControl.value);
  }

  /**
   * no se puede elegir una hora superior a max time
   */
  @Input() public set max(maxtimeInput: string) {
    if (maxtimeInput) {
      // tiempo para mostrar al usuario en caso de maxtime superado
      this.maxTimeMensajeTime = maxtimeInput;

      // validador de tiempo maximo superado
      this.inputValidators.push(new InputValidator(
        this.maxtimeValidatorFn(maxtimeInput),
        "maxtime"
      ));
    } else {
      this.inputValidators.forEach((inputvalidator: InputValidator, index: number) => {
        if (inputvalidator.nombre == 'maxtime') {
          this.inputValidators.splice(index, 1);
          return;
        }
      });
    }

    this.horaFormControl.setValidators(this.inputValidators.map((inputvalidator: InputValidator) => {
      return inputvalidator.validator;
    }));
    this.horaFormControl.updateValueAndValidity(this.horaFormControl.value);
  }

  @Input() public set time(valor: string) {
    if (valor) {
      var timeInput = valor.split(':');

      this.userTime = <ITime>{
        hour: +timeInput[0] || 0,
        minute: +timeInput[1] || 0,
        meriden: 'PM',
        format: 24
      };

      this.emituserTimeChange();
    } else {
      this.clearTime();
    }
  }
  public get time(): string {
    if (!this.userTime) {
      return '';
    }

    let meriden = `${this.userTime.meriden}`;
    if (this.userTime.format === 24) {
      meriden = '';
    }

    let hour = `${this.userTime.hour}`;
    if (this.userTime.hour === 24) {
      hour = '00';
    } else if (this.userTime.hour < 10) {
      hour = "0" + hour;
    }

    if (this.userTime.minute === 0) {
      return `${hour}:00` + ((meriden) ? ` ${meriden}` : ``);
    } else if (this.userTime.minute < 10) {
      const tt = '0' + String(this.userTime.minute);
      return `${hour}:${tt}` + ((meriden) ? ` ${meriden}` : ``);
    }

    return `${hour}:${this.userTime.minute}` + ((meriden) ? ` ${meriden}` : ``);
  }

  public showPicker() {
    let timeHoursDefault = (new Date).getHours();

    let timeMinutesDefault = Math.ceil((new Date).getMinutes() / 5) * 5;
    if (timeMinutesDefault == 60) {
      timeMinutesDefault = 0;
      timeHoursDefault++;
    }

    const dialogRef = this.dialog.open(WTimeDialogComponent, {
      data: {
        time: {
          hour: (this.userTime && this.userTime.hour) ? this.userTime.hour : timeHoursDefault,
          minute: (this.userTime && this.userTime.minute) ? this.userTime.minute : timeMinutesDefault,
          meriden: (this.userTime && this.userTime.meriden) ? this.userTime.meriden : 'PM',
          format: (this.userTime && this.userTime.format) ? this.userTime.format : 24,
        },
        color: this.color
      }
    });

    dialogRef.afterClosed()
      .subscribe((result: ITime | -1) => {
        if (result === undefined) {
          return;
        } else if (result !== -1) {
          this.userTime = result;
          this.emituserTimeChange();
        }
      });

    return false;
  }

  private emituserTimeChange() {
    this.horaFormControl.setValue(this.time);
    this.onChange.emit();
  }

  clearTime(): void {
    this.userTime = null;
    this.emituserTimeChange();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
